import { Record } from "immutable";

const TeaserInfRecord = new Record({
  id: undefined,
  category_name: "",
  image: "",
  title: "",
  url: ""
});

export default class TeaserInf extends TeaserInfRecord {}
